/* eslint-disable */
import React, { Component } from "react";
import Chart from "react-apexcharts";
import {
  Box,
  Card,
  CardContent,
  Divider,
  Tooltip,
  IconButton,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Grid,
  Typography,
  withStyles,
  Icon,
} from '@material-ui/core';
import { useStyles } from '../../style';
import roundWorkHistory from '../../../../../assets/icons/ic_round-work-history.png';
import utilidadesIcon from '../../../../../assets/icons/utilidadesIcon.svg';
import es from "../../../../../assets/languagePackages/es.json";

export default function ChartUtilidadNeta({ data }) {

  // console.log("dataUNRE", data)

  // const newData = {resEjercicio: [], utilidadNeta: []}

  // if(data.resEjercicio && data.utilidadNeta){
    

  //   newData.resEjercicio = data.resEjercicio.slice(0,-1)
  //   newData.utilidadNeta = data.utilidadNeta.slice(0,-1)
  // }

  // console.log("dataUNRE2", data)

  

  const classes = useStyles();

  const chartData = {
    series: [{
      name: 'Utilidad Neta (UN)',
      type: 'column',
      data: data.utilidadNeta
    },
      {
        name: 'Resultado Ejercicio',
        type: 'line',
        data: data.resEjercicio
      }
    ],
    options: {
      chart: {
        locales: [es],
        fontFamily: 'Roboto, sans-serif',
        defaultLocale: 'es',
        type: 'line',
        stacked: false,
        id: "basic-bar",
        zoom: {
          type: 'xy',
          autoScaleYaxis: true
        },
        dropShadow: {
          enabled: true,
          color: '#000',
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2
        },
        toolbar: {
          show: true
        },
      },
      plotOptions: {
        bar: {
          colors: {
            ranges: [
              {
                from: -Number.MAX_VALUE,
                to: 0,
                color: '#fac004' // Color para valores negativos
              },
              {
                from: 0,
                to: Number.MAX_VALUE,
                color: '#024788' // Color para valores positivos
              }
            ]
          },
          columnWidth: '50%',
        }
      },
      stroke: {
        width: [0, 2]
      },
      xaxis: {
        type: 'datetime',
      },
      yaxis: [
        {
          axisTicks: {
            show: true,
          },
          axisBorder: {
            show: true,
            color: '#024787'
          },
          labels: {
            style: {
              colors: '#024787',
            },
            formatter: function (y) {
              const formattedValue = y.toLocaleString(undefined, {
                style: 'currency',
                currency: 'USD',
              });
              return formattedValue;
            }
          },
          title: {
            text: "Utilidad Neta (UN)(USD)",
            style: {
              color: '#024787',
            }
          },
        },
        {
          seriesName: 'Utilidad Retenida',
          opposite: true,
          axisTicks: {
            show: true,
          },
          axisBorder: {
            show: true,
            color: '#6AA8C7'
          },
          labels: {
            style: {
              colors: '#6AA8C7',
            },
            formatter: function (y) {
              const formattedValue = y.toLocaleString(undefined, {
                style: 'currency',
                currency: 'USD',
              });
              return formattedValue;
            }
          },
          title: {
            text: "Resultado Ejercicio (USD)",
            style: {
              color: '#6AA8C7',
            }
          }
        },
      ],
      tooltip: {
        enabled: true,
        style: {
          fontFamily: 'Roboto, "sans-serif"',
        },
        intersect: false,
        custom: function({series, seriesIndex, dataPointIndex, w}) {
          // console.log("w", w)
          // console.log("series", series)
          // console.log("seriesIndex", seriesIndex)
          // console.log("dataPointIndex", dataPointIndex)
          const data = w.config.series;
          let nameNeta = ""
          let nameRetenida = ""
          if(seriesIndex === 1){
            nameNeta = w.config.series[1].name;
            nameRetenida = w.config.series[0].name;
          }else {
            nameNeta = w.config.series[0].name;
            nameRetenida = w.config.series[1].name;
          }
          
          const netaValue = w.config.series[seriesIndex].data[dataPointIndex] !== undefined ? w.config.series[seriesIndex].data[dataPointIndex] : [null,0];
          const date = new Date(netaValue[0]);
          const day = String(date.getUTCDate()).padStart(2, '0');
          const month = String(date.getUTCMonth() + 1).padStart(2, '0');
          const year = String(date.getUTCFullYear()).slice(-2);
          const formattedNetaValue = series[seriesIndex][dataPointIndex].toLocaleString(undefined, {
            style: 'currency',
            currency: 'USD',
          });
          let formattedRetenidaValue = ""
          if(seriesIndex === 1){
            formattedRetenidaValue =  series[0][dataPointIndex].toLocaleString(undefined, {
            style: 'currency',
            currency: 'USD',
          });
          }else{
            formattedRetenidaValue =  series[1][dataPointIndex].toLocaleString(undefined, {
            style: 'currency',
            currency: 'USD',
          });
          }

          let bgColor = ""
          let bgColor2 = ""
          if(seriesIndex === 1){
            bgColor = "#6AA8C7";
            bgColor2 = series[0][dataPointIndex] < 0 ? '#fac004' : '#024788'
            const formattedDate = `${day}/${month}/${year}`;
          return `
            <div style="border-radius:5px;font-family:'Roboto',serif;">
                <div style="display:flex;background:#ECEFF1;border-bottom:thin solid #ddd;padding-top:10px;padding-left:10px;padding-right:10px;padding-bottom:5px">
                    <p style="margin-left:5px">Fecha: <span style="font-weight:bold">${formattedDate}</span></p>
                </div>
                <div style="padding-bottom:10px;padding-left:10px;padding-right:10px;padding-top:5px">
                    <div style="display:flex;align-items:center">
                        <span style="background-color:${bgColor};width:12px;height:12px;border-radius:50%;margin-right:5px"></span>
                        <p>${nameNeta}: <span style="font-weight:bold">${formattedNetaValue}</span></p>
                    </div>
                    <div style="display:flex;align-items:center">
                        <span style="background-color:${bgColor2};width:12px;height:12px;border-radius:50%;margin-right:5px"></span>
                        <p>${nameRetenida}: <span style="font-weight:bold">${formattedRetenidaValue}</span></p>
                    </div>
                </div>
            </div>
        `
          }else {
            bgColor = "#6AA8C7";
            bgColor2 = series[0][dataPointIndex] < 0 ? '#fac004' : '#024788'
            const formattedDate = `${day}/${month}/${year}`;
          return `
            <div style="border-radius:5px;font-family:'Roboto',serif;">
                <div style="display:flex;background:#ECEFF1;border-bottom:thin solid #ddd;padding-top:10px;padding-left:10px;padding-right:10px;padding-bottom:5px">
                    <p style="margin-left:5px">Fecha: <span style="font-weight:bold">${formattedDate}</span></p>
                </div>
                <div style="padding-bottom:10px;padding-left:10px;padding-right:10px;padding-top:5px">
                    <div style="display:flex;align-items:center">
                        <span style="background-color:${bgColor2};width:12px;height:12px;border-radius:50%;margin-right:5px"></span>
                        <p>${nameNeta}: <span style="font-weight:bold">${formattedNetaValue}</span></p>
                    </div>
                    <div style="display:flex;align-items:center">
                        <span style="background-color:${bgColor};width:12px;height:12px;border-radius:50%;margin-right:5px"></span>
                        <p>${nameRetenida}: <span style="font-weight:bold">${formattedRetenidaValue}</span></p>
                    </div>
                </div>
            </div>
        `
          }
           
          
        }
      },
      legend: {
        horizontalAlign: 'left',
        offsetX: 40
      },
      colors: ['#024788','#6AA8C7']
      // colors: [function({ value, seriesIndex, dataPointIndex, w }) {
      //   console.log(value)
      //   if (seriesIndex === 0) {
      //     const prevValue = w.config.series[seriesIndex].data[dataPointIndex-1] !== undefined ? w.config.series[seriesIndex].data[dataPointIndex-1] : 0;
      //     console.log(prevValue)
      //     if (value < prevValue) {
      //       return '#fac004'
      //     } else {
      //       return '#024788'
      //     }
      //   } else {
      //     return '#6AA8C7'
      //   }
      // }],
    }
  }
  


  return (

    <Grid component={Card} padding={3}>
      <Grid className={classes.chartLineBarsBox} item xs={12} md={12}>
        <div>
          <img src={utilidadesIcon} alt="roundWorkHistory" width="35px" height="35px"/>
        </div>
        <Typography className={classes.chartBarDonutText} paddingLeft={2}>
        Utilidad Neta (UN) y Resultado Ejercicio
        </Typography>
      </Grid>
      <Grid item xs={12} md={12} height={300}>
        <Chart
          options={chartData.options}
          series={chartData.series}
          type="line"
          width="100%"
          height="100%"
        />
      </Grid>

    </Grid>


  );
}
